import { render, staticRenderFns } from "./BusesTable.vue?vue&type=template&id=677b12aa&scoped=true"
import script from "./BusesTable.vue?vue&type=script&lang=js"
export * from "./BusesTable.vue?vue&type=script&lang=js"
import style0 from "./BusesTable.vue?vue&type=style&index=0&id=677b12aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677b12aa",
  null
  
)

export default component.exports